var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i-header',{staticClass:"toolbar"},[_c('row',{class:[
      'toolbar__row layout-container',
      _vm.isFullWidthRoute ? 'full-width' : ''
    ]},[_c('i-col',{staticClass:"toolbar__col menu",attrs:{"span":_vm.type === 'contract' ? 16 : 14}},[_vm._t("menu")],2),_c('i-col',{staticClass:"toolbar__col tools",attrs:{"span":_vm.type === 'contract' ? 8 : 10}},[_vm._t("tools")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }